/* src/app/header/header.component.scss */
:host {
  position: relative;
}
@media screen and (max-width: 767px) {
  .container-1 {
    height: 76px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1480px) {
  .container-1 {
    height: 64px;
    margin: 0px 60px 23px;
  }
}
@media (min-width: 1481px) {
  .container-1 {
    margin: 0px 112px 23px;
  }
}
@media screen and (max-width: 767px) {
  .logo {
    padding-left: 24px;
  }
}
.header {
  padding-top: 22px;
}
@media screen and (max-width: 739px) {
  .header {
    margin-bottom: 18px !important;
  }
}
@media screen and (max-width: 767px) {
  .header {
    height: 88px;
  }
}
@media screen and (min-width: 768px) {
  .header {
    height: 108px;
  }
}
.header.border-bottom {
  border-bottom-color: #D8D8D8;
}
.trailer-reservation-suite {
  padding-left: 40px;
  font-weight: 400;
  line-height: 24px;
  width: 256px;
  min-width: 256px;
  margin-bottom: 5px;
}
@media screen and (max-width: 767px) {
  .trailer-reservation-suite {
    padding-left: 1rem;
    margin-bottom: 0;
  }
}
@media screen and (max-width: 767px) {
  h4 {
    font-size: 16px;
  }
}
@media screen and (min-width: 768px) {
  h4 {
    font-size: 20px;
  }
}
@media screen and (max-width: 767px) {
  .ups-shield {
    max-height: 32px;
    max-width: 27.12px;
  }
}
@media screen and (min-width: 768px) {
  .ups-shield {
    max-height: 64px;
    max-width: 54.24px;
  }
}
.icon-text {
  font-size: 12px;
}
@media screen and (max-width: 1300px) {
  .icon-text {
    display: none;
  }
}
.icon {
  align-self: center;
  font-family: upsicons, fantasy !important;
  color: #000;
}
.icon.user:before {
  content: "\e6da";
}
@media screen and (max-width: 1300px) {
  .icon.user.show:before {
    content: "\e67b";
  }
}
.icon.globe:before {
  content: "\e63e";
}
@media screen and (max-width: 767px) {
  .icon.globe.show:before {
    content: "\e67b";
  }
}
.links {
  color: black;
  font-size: 16px;
  display: block;
  text-decoration: none;
  padding-left: 24px;
  padding-right: 24px;
}
.links:hover {
  text-decoration: none;
}
.full-name {
  width: 200px;
}
.name button {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  padding: 0.625rem 0.5rem;
  color: #fff;
  background-color: #0662bb;
  border: 2px solid #0662bb;
  line-height: 1.3;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.35s ease-in-out;
  margin-left: 1rem;
}
.name button:after {
  display: none;
}
.name,
.signup {
  color: #000;
  font-size: 12px;
  padding-left: 2px !important;
}
.name:hover {
  text-decoration: none;
}
@media screen and (min-width: 1300px) {
  .language-link:after {
    content: "\e626" !important;
    font-family: upsicons, fantasy !important;
    font-size: 12px;
    line-height: 12px;
    vertical-align: center;
    margin-left: 1rem;
  }
}
.language-link .icon-text {
  padding-left: 4px;
}
.btn-link {
  text-align: left;
}
.btn-link:hover {
  text-decoration: none;
  background-color: #f2f1ef;
}
@media screen and (min-width: 1300px) {
  .links-bubble {
    position: absolute;
    width: 220px;
    z-index: 100 !important;
    top: 90px;
    height: 0;
    transition: 0.25s ease height;
    padding: 0;
  }
  .links-bubble.show {
    padding: 8px 0;
    background-color: white;
    border: 1px solid #757575;
    height: auto;
  }
  .links-bubble .personal-links,
  .links-bubble .language-links {
    overflow: hidden;
    height: 100%;
  }
  .links-bubble hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
@media screen and (max-width: 1300px) {
  .links-bubble {
    position: fixed;
    z-index: 1000 !important;
    top: 90px;
    height: 0;
    padding: 0;
  }
  .links-bubble.language-links-bubble {
    display: none !important;
  }
  .links-bubble.show {
    padding: 19px;
    background-color: white;
    border: 1px solid #757575;
    height: auto;
    margin: 0px 22px;
  }
  .links-bubble .personal-links,
  .links-bubble .language-links {
    overflow: hidden;
    height: 100%;
  }
  .links-bubble hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
@media screen and (min-width: 1481px) {
  .language-menu {
    right: 196px;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1480px) {
  .language-menu {
    right: 144px;
  }
}
@media screen and (min-width: 1481px) {
  .personal-menu {
    right: 112px;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1480px) {
  .personal-menu {
    right: 60px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1300px) {
  .personal-menu {
    right: 92px;
  }
}
.menu-container {
  display: flex;
  padding-left: 72px;
}
div.menus {
  width: 193px;
}
.menus {
  color: black;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  display: block;
  text-decoration: none;
  border-bottom: 2px solid var(--bs-info-text-emphasis);
  border-color: transparent;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
}
.menus::after {
  content: "";
  opacity: 0;
  transition: all 350ms ease-in-out;
  position: absolute;
  margin: 0;
  bottom: -0.5rem;
  left: 50%;
  border: none;
  width: 0;
  height: 0.25rem;
  border-radius: 1px;
  background-color: #ffc400;
}
.menus:hover {
  text-decoration: none;
}
.menus:hover::after {
  opacity: 1;
  left: calc(50% - 1rem);
  width: 2rem;
}
.ncm-link {
  margin-left: 32px;
}
.selected-menu::after {
  opacity: 1;
  left: calc(50% - 1rem);
  width: 2rem;
}
.submenu-container {
  display: flex;
  position: absolute;
  background-color: white;
  width: 100%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
  z-index: 999;
  padding: 1.2rem 7.5rem;
}
.submenu-container .submenu {
  margin-right: 11rem;
  justify-content: start;
}
.submenu-container .submenu .submenu-label {
  width: 100%;
  font-size: 0.75rem;
  line-height: 1.5;
  font-weight: 500;
  color: #121212;
  text-transform: uppercase;
  letter-spacing: 1.8px;
  margin-bottom: 1.25rem;
}
.submenu-container .submenu .link {
  display: inline-block;
  text-decoration: none;
  line-height: 1.25;
  word-wrap: break-word;
  font-size: 1rem;
  font-weight: 500;
  color: #5f5753 !important;
  margin-bottom: 1.25rem;
  position: relative;
  padding-right: 1.5rem;
  -webkit-user-select: none;
  user-select: none;
}
.submenu-container .submenu .link .ups-icon {
  padding-left: 0.5rem;
  text-decoration: none !important;
}
.header-menu {
  display: flex;
  align-items: center;
}
.menu-hamburger {
  display: none;
}
@media screen and (max-width: 767px) {
  .menu-hamburger {
    display: flex;
    font-size: 18px;
    padding-top: 8px;
    padding-left: 0;
    padding-right: 8px;
  }
}
@media (min-width: 768px) and (max-width: 1300px) {
  .menu-hamburger {
    display: flex;
    font-size: 18px;
    padding-top: 8px;
    padding-left: 20px;
  }
}
.menu-hamburger-dropdown-container {
  display: none;
  position: relative;
}
@media screen and (min-width: 768px) and (max-width: 1300px) {
  .menu-hamburger-dropdown-container {
    right: 1.9rem;
  }
}
@media screen and (max-width: 1300px) {
  .language-link {
    display: none !important;
  }
  .menu-container {
    display: none;
  }
  .submenu-container {
    display: none;
  }
  .menu-hamburger-dropdown-container {
    display: flex;
    flex-flow: column;
    position: absolute;
    top: 6.5rem;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
    width: 400px;
    background-color: white;
    z-index: 1000;
    padding: 0 30px;
  }
  .menu-hamburger-dropdown-container .menu-hamburger-toggle {
    color: #121212;
    padding: 0.5rem 0;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #BFB8AF;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
  .menu-hamburger-dropdown-container .menu-hamburger-toggle.selected-menu {
    border-bottom: 4px solid #ffc400;
  }
  .menu-hamburger-dropdown-container .hamburger-language-divider {
    height: 5rem;
    width: 100%;
  }
  .menu-hamburger-dropdown-container .menu-submenu-header {
    padding: 0.5rem 0;
    padding-top: 12px;
    font-size: 12px;
    font-weight: 600;
  }
  .menu-hamburger-dropdown-container .link {
    font-size: 16px;
    text-decoration: none;
    color: #5F5753 !important;
    padding: 12px 8px;
  }
  .menu-hamburger-dropdown-container .link .ups-icon {
    padding-left: 0.5rem;
    text-decoration: none !important;
  }
}
@media screen and (max-width: 767px) {
  .menu-hamburger-dropdown-container {
    top: 4.5rem;
    width: 95%;
  }
  .links-bubble.show {
    right: 52px;
    top: 78px;
  }
}
/*# sourceMappingURL=header.component.css.map */
